import { getPreInitResponse, type ApiClient } from '@ael/core-api';
import { OnlineStudentViewModes } from '../../constants';
import { PreInitResult } from "../../configs";

export type InitResult = {
  isSuccess: true;
  preInitData: PreInitResult;
};

export type FailedInitResult = {
  isSuccess: false;
  reason: 'not found' | 'unknown';
};

export async function applicationPreInit(
  apiClient: ApiClient,
  viewMode: OnlineStudentViewModes,
  guid: string,
): Promise<InitResult | FailedInitResult> {
  const preInitResponse = await getPreInitResponse(apiClient, viewMode, guid);
  switch (preInitResponse.status) {
    case 200: {
      const preInitData  = await preInitResponse.json();
      return { isSuccess: true, preInitData };
    }
    case 404:
      return { isSuccess: false, reason: 'not found' };
    default:
      return { isSuccess: false, reason: 'unknown' };
  }
}

 